import { observer } from 'mobx-react-lite'
import { useRunState } from '@/src/game/provider/useRunState'
import { store } from '@/src/stores/store'
import { useEffect } from 'react'

export const InputController = observer(function InputController() {
    const runState = useRunState()

    const isGameplayInputEnabled =
        store.appFlowPhase === 'run' &&
        runState.phase === 'running' &&
        !store.debugFreeFlyCameraEnabled

    useEffect(() => {
        function onKeyDown(event: KeyboardEvent) {
            if (!isGameplayInputEnabled) return
            if (event.repeat) return

            if (event.key === 'ArrowLeft' || event.key.toLowerCase() === 'a') {
                runState.moveLane(-1)
            }

            if (event.key === 'ArrowRight' || event.key.toLowerCase() === 'd') {
                runState.moveLane(1)
            }

            if (event.key === ' ' || event.key === 'ArrowUp' || event.key.toLowerCase() === 'w') {
                event.preventDefault()
                runState.startJump()
            }
        }

        window.addEventListener('keydown', onKeyDown)

        return () => {
            window.removeEventListener('keydown', onKeyDown)
        }
    }, [isGameplayInputEnabled, runState])

    if (!isGameplayInputEnabled) return null

    return null
})
